import { db } from "common/config/Firebase"
import { calculateTotalInvoice } from "./calculateInvoicesInfo"
import BusEvent from "common/services/BusEvent"

const invoiceCollection = db.collection('invoices')
const invoiceDetailCollection = db.collection('invoiceDetail')

const updateInvoiceDetailUseCase = async (invoice, ivaPercent, detail) => {
    console.log("Actu")
    const { base, total } = calculateTotalInvoice(detail.data, ivaPercent)

    const updateData = { basePrice: base, totalPrice: total }

    if (detail.data && detail.data.length > 0) {
        const allConcepts = detail.data
            .map(d => {
                const parts = [d.description, d.reference].filter(Boolean);
                return parts.join(' - ');
            })
            .filter(Boolean)
            .join('\n');
        
        updateData.concept = allConcepts; // Guarda TODO en concept
        invoice.concept = allConcepts; // Actualiza el objeto en memoria también
    }

    await invoiceCollection.doc(invoice.id).update(updateData)
    BusEvent.publish(BusEvent.UPDATE_INVOICE, { invoice: {...invoice, totalPrice: total, concept: updateData.concept }, oldInvoice: invoice })
    return invoiceDetailCollection.doc(invoice.id).set(detail)
}

export default updateInvoiceDetailUseCase